/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Event form instance serializer.
 * @export
 * @interface EventFormInstance
 */
export interface EventFormInstance {
    /**
     * 
     * @type {number}
     * @memberof EventFormInstance
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof EventFormInstance
     */
    form: number;
    /**
     * 
     * @type {string}
     * @memberof EventFormInstance
     */
    event: string;
}

/**
 * Check if a given object implements the EventFormInstance interface.
 */
export function instanceOfEventFormInstance(value: object): value is EventFormInstance {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('form' in value) || value['form'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    return true;
}

export function EventFormInstanceFromJSON(json: any): EventFormInstance {
    return EventFormInstanceFromJSONTyped(json, false);
}

export function EventFormInstanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventFormInstance {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'form': json['form'],
        'event': json['event'],
    };
}

export function EventFormInstanceToJSON(json: any): EventFormInstance {
    return EventFormInstanceToJSONTyped(json, false);
}

export function EventFormInstanceToJSONTyped(value?: Omit<EventFormInstance, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'form': value['form'],
        'event': value['event'],
    };
}

